import { html } from 'lit';

/**
 * Encompass's words for the loan data PBG cannot order without, or would like DocPrep to have --
 * the labels EpcLoanReadiness puts into its sentence, its list lines and its recommendations.
 * Longest first, so "borrower with a first and last name" wins over any shorter overlap and
 * "street address" over "current address" over nothing. Keep in step with EpcLoanReadiness.cs.
 */
const MISSING_TERMS = [
  'borrower with a first and last name',
  'PUD / subdivision name',
  'legal description',
  'settlement agent',
  'marital status',
  'current address',
  'closing date',
  'loan amount',
  'street address',
  'date of birth',
  'loan purpose',
  'loan number',
  'loan type',
  'ZIP code',
  'address',
  'seller',
  'email',
  'phone',
  'city',
  'state',
  'SSN',
];

const escape = (t) => t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const PATTERN = new RegExp(`\\b(${MISSING_TERMS.map(escape).join('|')})\\b`, 'gi');

/**
 * The text with each missing item in bold. Officers skim; the one thing they must take from the
 * screen is what to fix in Encompass. Text stays text: the pieces go through lit's escaping, never
 * innerHTML.
 */
export function emphasiseTerms(text) {
  if (!text) return html``;
  const parts = text.split(PATTERN);
  return html`${parts.map((part, i) => (i % 2 === 1 ? html`<b>${part}</b>` : part))}`;
}

/**
 * The same, for a whole sentence from the server -- applied only to a missing-data sentence (one
 * that starts "This loan "), so a generic failure that happens to say "state" or "email" is left
 * alone.
 */
export function emphasiseMissing(text) {
  if (!text) return html``;
  if (!text.startsWith('This loan ')) return html`${text}`;
  return emphasiseTerms(text);
}
